// ============================================================================
// bootstrapEmbeddedSections — registers litigation self-managing widgets
// ============================================================================
// Wires the Accounts / Respondents sections (which own their persistence) into
// the common DynamicForm via the embeddedSectionRegistry, so a form_spec
// section authored as `type: 'accounts'` / `type: 'respondents'` renders the
// real component. Called once at app boot (App.tsx). Keeps `common/DynamicForm`
// free of a static import into this feature module (ADR-0002 §2.4).

import React from 'react';
import {
  registerEmbeddedSection,
  type EmbeddedSectionProps,
} from 'components/common/DynamicForm/embeddedSectionRegistry';
import type { LitigationCase } from 'api/types/litigationCase.types';
import CaseAccountsSection from './sections/CaseAccountsSection';
import CaseRespondentsSection from './sections/CaseRespondentsSection';
import CaseDetailsSection from './sections/CaseDetailsSection';

const NOOP = () => { /* embedded sections self-refetch; no parent refresh needed */ };

const AccountsWidget: React.FC<EmbeddedSectionProps> = ({ seedContext }) => {
  const kase = seedContext?.kase as LitigationCase | undefined;
  if (!kase) return null;
  return <CaseAccountsSection kase={kase} onMutated={NOOP} />;
};

const RespondentsWidget: React.FC<EmbeddedSectionProps> = ({ seedContext }) => {
  const kase = seedContext?.kase as LitigationCase | undefined;
  if (!kase) return null;
  return <CaseRespondentsSection kase={kase} onMutated={NOOP} />;
};

const CaseDetailsWidget: React.FC<EmbeddedSectionProps> = ({ seedContext }) => {
  const kase = seedContext?.kase as LitigationCase | undefined;
  if (!kase) return null;
  return <CaseDetailsSection kase={kase} onMutated={NOOP} />;
};

export function bootstrapEmbeddedSections(): void {
  registerEmbeddedSection('accounts', AccountsWidget);
  registerEmbeddedSection('respondents', RespondentsWidget);
  registerEmbeddedSection('case_details', CaseDetailsWidget);
}
